import React, { useState, useEffect, useContext, useRef } from 'react';
import moment from 'moment'

import { useSpeechSynthesis } from 'react-speech-kit';

import { sortBy } from 'lodash';
import '../../css/Table.css';
import { AlertContext } from '../../AlertContext';

const DisplayCustomers = ({ apiUrl }) => {
  const { showAlert } = useContext(AlertContext);

  const [customers, setCustomers] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [sortOrder, setSortOrder] = useState('');
  const [selectedCustomers, setSelectedCustomers] = useState([]);

  const {speak} = useSpeechSynthesis()
  const fetchCustomerData = async () => {
    try {
      const response = await fetch(`${apiUrl}/dashboard/customer/display`);
      const data = await response.json();
      setCustomers(data);
      if (response.status === 200) {
        showAlert('Fetched Data Successfully', 'success');
      } else {
        showAlert('Error in fetching Customer Details', 'danger')
      }
    } catch (error) {
      console.error('Error fetching customer data:', error);
    }
  };

  const fetchCustomerDataRef = useRef(fetchCustomerData);

  useEffect(() => {
    fetchCustomerDataRef.current();
  }, []);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    let filteredData = customers.filter(
      (customer) =>
        customer.firstname.toLowerCase().includes(searchQuery.toLowerCase()) ||
        customer.lastname.toLowerCase().includes(searchQuery.toLowerCase())
    );

    if (sortOrder === 'asc') {
      filteredData = sortBy(filteredData, (customer) => moment(customer.nextservicedue).toDate());
    } else {
      filteredData = sortBy(filteredData, (customer) => moment(customer.nextservicedue).toDate()).reverse();
    }

    setFilteredCustomers(filteredData);
  };


  const resetSearch = () => {
    setSearchQuery('');
    setFilteredCustomers([]);
  };

  const handleSort = () => {
    if (sortOrder === 'asc') {
      const sortedCustomers = displayData.slice().sort((a, b) => moment(a.nextservicedue).toDate() - moment(b.nextservicedue).toDate());
      setFilteredCustomers(sortedCustomers);
      setSortOrder('desc');
    } else {
      const sortedCustomers = displayData.slice().sort((a, b) => moment(b.nextservicedue).toDate() - moment(a.nextservicedue).toDate());
      setFilteredCustomers(sortedCustomers);
      setSortOrder('asc');
    }
  };

  const handleSortbyDay = () => {
    const currentDate = moment(); // Get the current date

    if (sortOrder === 'asc') {
      const sortedCustomers = displayData.slice().sort((a, b) => {
        const dateA = moment(a.nextservicedue, 'DD-MM');
        const dateB = moment(b.nextservicedue, 'DD-MM');

        // Compare the day and month of the next service dates
        if (dateA.isBefore(currentDate) && dateB.isSameOrAfter(currentDate)) {
          return 1; // Move dates before the current date to the end
        } else if (dateA.isSameOrAfter(currentDate) && dateB.isBefore(currentDate)) {
          return -1; // Move dates after the current date to the beginning
        } else {
          return dateA.diff(dateB, 'days'); // Sort the remaining dates based on day and month
        }
      });

      setFilteredCustomers(sortedCustomers);
      setSortOrder('desc');
    } else {
      const sortedCustomers = displayData.slice().sort((a, b) => {
        const dateA = moment(a.nextservicedue, 'DD-MM');
        const dateB = moment(b.nextservicedue, 'DD-MM');

        // Compare the day and month of the next service dates
        if (dateA.isBefore(currentDate) && dateB.isSameOrAfter(currentDate)) {
          return -1; // Move dates before the current date to the beginning
        } else if (dateA.isSameOrAfter(currentDate) && dateB.isBefore(currentDate)) {
          return 1; // Move dates after the current date to the end
        } else {
          return dateB.diff(dateA, 'days'); // Sort the remaining dates based on day and month
        }
      });

      setFilteredCustomers(sortedCustomers);
      setSortOrder('asc');
    }
  };

  const handleSelectCustomer = (customer) => {
    const isSelected = selectedCustomers.includes(customer);

    if (isSelected) {
      setSelectedCustomers(selectedCustomers.filter((c) => c !== customer));
    } else {
      setSelectedCustomers([...selectedCustomers, customer]);
    }
  };

  const displayData = filteredCustomers.length > 0 ? filteredCustomers : customers;

  const handleSpeakTop5Customers = () => {
    const top5Customers = displayData.slice(0, 3); // Get the top 5 customers from displayData
    const customerDetails = top5Customers.map((customer, index) => {
      return `${index + 1}. ${customer.firstname} ${customer.lastname}, Next Service Due on ${moment(customer.nextservicedue).format('DD-MM-YYYY')}, Contact Number: ${customer.contact}.`;
    }).join(' ');

    speak({ text: `Top 5 customers based on next service: ${customerDetails}` }); // Speak out the top 5 customers
  };

  const sendMessages = async () => {
    try {
      const response = await fetch(`${apiUrl}/send-messages`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ selectedCustomers }),
      });

      if (response.ok) {
        showAlert('Messages sent successfully', 'success');
      } else {
        showAlert('Error sending messages', 'danger');
      }
    } catch (error) {
      console.error('Error sending messages:', error);
    }
  };

  return (
    <div className="container">
      <h3>Customer Details:</h3>
      <div className="search-container">
        <form onSubmit={handleSearchSubmit} className="mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="Search by name"
            value={searchQuery}
            onChange={handleSearchChange}
          />
          <div className="search-btn">
            <button type="submit" className="btn btn-sm search btn-primary">
              Search
            </button>
            <button type="button" className="btn btn-sm search btn-secondary" onClick={resetSearch}>
              Reset
            </button>
            <button onClick={handleSpeakTop5Customers} className="btn btn-sm btn-info">
          Speak Top 5 Customers
        </button>
          </div>
        </form>
      </div>
      <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th>Select
                {/* <input type="checkbox" onChange={handleSelectAll} /> */}
              </th>
              <th>Id</th>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Water Purifier</th>
              <th>Type</th>
              <th>Cost</th>
              <th>Installation</th>
              <th>Last Service</th>
              <th onClick={handleSortbyDay} style={{ cursor: 'pointer' }}>
                Next Service {sortOrder === 'asc' ? <span>&#9650;</span> : <span>&#9660;</span>}
              </th>
              <th>Contact</th>
              <th>Address</th>
            </tr>
          </thead>
          <tbody>
            {displayData.map((customer) => (
              <React.Fragment key={customer.customerId}>
                <tr key={customer.customerId}>
                  <td>
                    <input
                      type="checkbox"
                      checked={selectedCustomers.includes(customer)}
                      onChange={() => handleSelectCustomer(customer)}
                    />
                  </td>
                  <td>{customer.customerId}</td>
                  <td>{customer.firstname}</td>
                  <td>{customer.lastname}</td>
                  <td>{customer.waterpurifier}</td>
                  <td>{customer.waterpurifier_type}</td>
                  <td>{customer.cost}</td>
                  <td>{moment(customer.date_of_installation).format('DD-MM-YYYY')}</td>
                  <td>{moment(customer.date_last_service).format('DD-MM-YYYY')}</td>
                  <td>{moment(customer.nextservicedue).format('DD-MM-YYYY')}</td>
                  <td>{customer.contact}</td>
                  <td>{customer.address}</td>

                </tr>
                {selectedCustomers.includes(customer) && (
                  <tr>
                    <td colSpan="12">
                      <table className="service-history-table" style={{ "marginLeft": "auto", "marginRight": "auto" }}>
                        <thead>
                          <tr>
                            <th>Last Service Date</th>
                            <th>Description</th>
                          </tr>
                        </thead>
                        <tbody>
                          {customer.service_history.map((history) => (
                            <tr key={history._id}>
                              <td>{moment(history.last_service_date).format('DD-MM-YYYY')}</td>
                              <td>{history.description}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
      <div className="search-btn">
          <button onClick={handleSort} className="btn btn-sm btn-warning">
            Sort by Latest Service {sortOrder === 'asc' ? <span>&#9650;</span> : <span>&#9660;</span>}
          </button>
        </div>
      <div className='msg-container'>
        <h3>Selected Customers:</h3>
        <ol>
          {selectedCustomers.map((customer) => (
            <li className='form-field' key={customer.customerId}>
              <span>Name:</span> {customer.firstname} {customer.lastname}<br /><span>Phone :</span>{customer.contact}
            </li>
          ))}
        </ol>
        <div className="search-btn">
          <button disabled={selectedCustomers.length === 0} type="submit" onClick={sendMessages} className="btn search btn-sm btn-success">
            Send Message
          </button>
        </div>
      </div>

    </div>
  );
};

export default DisplayCustomers;
